import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../view/index.vue";
import Home from "../view/home.vue";
import platformIntroduce from "../view/platformIntroduce.vue";
import aboutUs from "../view/aboutUs.vue";
import NewDetail from "../view/newsDetail.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/NewDetail",
    name: "NewDetail",
    component: NewDetail,
  },
  {
    path: "/platformIntroduce",
    name: "platformIntroduce",
    component: platformIntroduce,
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: aboutUs,
  },
 
  
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
